import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
  Logo,
  ExternalLink,
  NamedLink,
} from '../../components';

import css from './Footer.module.css';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';

const renderSocialMediaLinks = intl => {
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
      <IconSocialMediaFacebook />
    </ExternalLink>
  ) : null;

  const twitterLink = siteTwitterPage ? (
    <ExternalLink
      key="linkToTwitter"
      href={siteTwitterPage}
      className={css.icon}
      title={goToTwitter}
    >
      <IconSocialMediaTwitter />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  return [fbLink, twitterLink, instragramLink].filter(v => v != null);
};

const Footer = props => {
  const { rootClassName, className, intl, currentUser } = props;
  const socialMediaLinks = renderSocialMediaLinks(intl);
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          <div className={css.someLiksMobile}>{socialMediaLinks}</div>
          <div className={css.links}>
            <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}>
                <span className={css.logo}>
                  <Logo format="desktop" />
                </span>
              </NamedLink>
              <div className={css.organizationInfo}>
                <p className={css.organizationDescription}>
                  <FormattedMessage id="Footer.organizationDescription" />
                </p>
                <p className={css.organizationCopyright}>
                  <NamedLink name="LandingPage" className={css.copyrightLink}>
                    <FormattedMessage id="Footer.copyright" />
                  </NamedLink>
                </p>
              </div>
            </div>
            <div className={css.infoLinks}>
              <ul className={css.list}>
                <li className={css.listItem}>
                  {currentUser?.attributes?.profile?.publicData?.userType === 'doctor' ? (
                    <NamedLink name="NewListingPage" className={css.link}>
                      <FormattedMessage id="Footer.toNewListingPage" />
                    </NamedLink>
                  ) : null}
                </li>
                <li className={css.listItem}>
                  <NamedLink name="AboutPage" className={css.link}>
                    <FormattedMessage id="Footer.toAboutPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="FrequentlyAskedQuestion" className={css.link}>
                    <FormattedMessage id="Footer.toFAQPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="HelpPage" className={css.link}>
                    <FormattedMessage id="Footer.toHelpPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="ContactUsPage" className={css.link}>
                    <FormattedMessage id="Footer.toContactPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                    <a href="https://find-avet.notion.site/Documentation-71cffe3dffb54e1eb3b81b5fa3239d34?pvs=4"
                      className={css.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FormattedMessage id="Footer.toDocumentation" />
                    </a>
                  </li>
              </ul>
            </div>
            <div className={css.searches}>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Frankfurt%2C%20Hesse%2C%20Germany&bounds=50.22687%2C8.800351%2C50.01549%2C8.472658',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchFrankfurt" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Berlin%2C%20Germany&bounds=52.6755029827484%2C13.761131997363%2C52.3382670008426%2C13.0883590415111',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchBerlin" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Hamburg%2C%20Germany&bounds=54.0187463964527%2C10.3253449681247%2C53.3949960146367%2C8.30956670062143',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchHamburg" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=M%C3%BCnchen%20Karlsplatz%20station%2C%20Karlsplatz%2C%20Munich%2C%20Bavaria%2080335%2C%20Germany&bounds=48.157190555541426%2C11.592652958755066%2C48.12125794445857%2C11.538807041244931',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchMunchen" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=K%C3%B6ln%20Arcaden%2C%20Kalker%20Hauptstr.%2055%2C%20Cologne%2C%20North%20Rhine-Westphalia%2051103%2C%20Germany&bounds=50.95553630554143%2C7.027095396720295%2C50.91960369445857%2C6.970074603279706',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchKoln" />
                  </NamedLink>
                </li>
              </ul>
            </div>
            <div className={css.searchesExtra}>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Stuttgart%2C%20Baden-Württemberg%2C%20Germany&bounds=48.866405%2C9.315827%2C48.692024%2C9.038606',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchStuttgart" />
                  </NamedLink>
                </li>

                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=D%C3%BCsseldorf%2C%20North%20Rhine-Westphalia%2C%20Germany&bounds=51.352473%2C6.939884%2C51.124319%2C6.688644',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchDusseldorf" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Leipzig%2C%20Saxony%2C%20Germany&bounds=51.447065%2C12.54258%2C51.23808%2C12.236476',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchLeipzig" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Dortmund%2C%20North%20Rhine-Westphalia%2C%20Germany&bounds=51.600246%2C7.63837%2C51.415624%2C7.302245',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchDortmund" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search:
                        '?address=Essen%2C%20North%20Rhine-Westphalia%2C%20Germany&bounds=51.534014%2C7.137918%2C51.34746%2C6.894457',
                    }}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.searchEssen" />
                  </NamedLink>
                </li>
              </ul>
            </div>
            <div className={css.extraLinks}>
              <div className={css.someLinks}>{socialMediaLinks}</div>
              <div className={css.legalMatters}>
                <ul className={css.tosAndPrivacy}>
                  <li>
                    <NamedLink name="TermsOfServicePage" className={css.legalLink}>
                      <FormattedMessage id="Footer.termsOfUse" />
                    </NamedLink>
                  </li>
                  <li>
                    <NamedLink name="PrivacyPolicyPage" className={css.legalLink}>
                      <FormattedMessage id="Footer.privacyPolicy" />
                    </NamedLink>
                  </li>
                  <li>
                    <NamedLink name="ImprintPage" className={css.legalLink}>
                      <FormattedMessage id="Footer.imprint" />
                    </NamedLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={css.copyrightAndTermsMobile}>
            <NamedLink name="LandingPage" className={css.organizationCopyrightMobile}>
              <FormattedMessage id="Footer.copyright" />
            </NamedLink>
            <div className={css.tosAndPrivacyMobile}>
              <NamedLink name="PrivacyPolicyPage" className={css.privacy}>
                <FormattedMessage id="Footer.privacy" />
              </NamedLink>
              <NamedLink name="TermsOfServicePage" className={css.terms}>
                <FormattedMessage id="Footer.terms" />
              </NamedLink>
              <NamedLink name="ImprintPage" className={css.imprint}>
                <FormattedMessage id="Footer.imprint" />
              </NamedLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};
const mapStateToProps = state => {
  const { currentUser } = state.user;
  return { currentUser };
};
export default compose(
  withRouter,
  connect(
    mapStateToProps
    // mapDispatchToProps
  )
)(injectIntl(Footer));
